import WheelLuck from './WheelLuck'

export default WheelLuck
